<div>
  @if (hidePrevFeat) {
    <div>
      @for (feat of allFeatures; track feat) {
        <div class="row">
          <div class="col-2"></div>
          <div class="col-12">
            @if (invertedImg) {
              <img alt="inverted" class="tick-img" src="{{pathVal}}Feature_not_written.png">
            }
            @if (!invertedImg) {
              <img class="tick-img" alt="not Inverted"
                src="{{pathVal}}feature_not_checked.png">
            }
            &nbsp;&nbsp;{{feat}}
          </div>
        </div>
      }
    </div>
  }


  @if (!hidePrevFeat) {
    <div>
      @for (feat of combineAllFeat; track feat) {
        <div class="row">
          <div class="col-2"></div>
          @if (feat.flag === 'green') {
            <div class="col-12"><img class="tick-img"
            src="{{pathVal}}check_circle.png" alt="check circle">&nbsp;&nbsp;{{feat.name}}</div>
          }
          @if (feat.flag === 'orange') {
            <div class="col-12"><img class="tick-img"
            src="{{pathVal}}caution_orange.png" alt="caution orange">&nbsp;&nbsp;{{feat.name}}</div>
          }
          @if (feat.flag === 'red') {
            <div class="col-12"><img class="tick-img"
            src="{{pathVal}}error_red.png" alt="error red">&nbsp;&nbsp;{{feat.name}}</div>
          }
        </div>
      }
    </div>
  }
</div>
@if (customerLoader) {
  <img src="{{pathVal}}dash-spinner.gif" alt="dash spinner" class="dash-border text-secondary custom-spinner">
}
